import { render, staticRenderFns } from "./LayoutEmailForm.vue?vue&type=template&id=9202503e&scoped=true&"
import script from "./LayoutEmailForm.vue?vue&type=script&lang=js&"
export * from "./LayoutEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./LayoutEmailForm.vue?vue&type=style&index=0&id=9202503e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9202503e",
  null
  
)

export default component.exports